import React from 'react';

import { Settings } from 'components';

export const MerchantSettingsPage: React.FC = () => <Settings />;
